module.exports = __webpack_public_path__ + "img/loginbg.598e873b.png";